import { ReactComponent as IconChevronDown } from '@/assets/svgs/profile-chevron.svg'
import rem from '@/utils/rem'
import classname from 'classnames'
import React, { useCallback, useRef, useState, useEffect } from "react"
import { Manager, Popper, Reference } from "react-popper"
import MultiClamp from 'react-multi-clamp'
import clickCheck from '@/utils/click-check'

export const Toggle = (setOpen, isOpen) => {
    setOpen(!isOpen)
}

export function PopoverFunction(setListReference, maxWidth, isOpen, options, value, Select) {
    return <Popper placement="bottom"
        modifiers={[
            {
                name: 'preventOverflow',
                enabled: true
            },
            {
                name: 'offset',
                options: { offset: [0, 6] }
            }
        ]}
    >
        {({ ref, style, placement }) => (
            <div ref={node => setListReference(node, ref)} style={{ ...style, width: maxWidth, maxWidth }} data-placement={placement}
                className={`dropdown__list ${(isOpen && "dropdown__list--open") || ""}`}>
                {options.map((item, index) => {
                    let check = "ALL";
                    if (value === "DOCUMENT") check = "DOCUMENT";
                    if (value === "EVENT") check = "EVENT";
                    return (
                        <div className={check === item.value ? 'dropdown__item dropdown__item__selected' : 'dropdown__item'} onClick={() => Select(item)} key={index}>
                            <span className={'dropdown__item-span__margin'} title={item.name}>{item.name}</span>
                        </div>
                    )
                })}
            </div>
        )}
    </Popper>
}

export function SetDataForButtonReference(buttonRef, listRef) {
    const setButtonReference = useCallback((node, ref) => {
        buttonRef.current = node
        return ref(node)
    }, [])

    const setListReference = useCallback((node, ref) => {
        listRef.current = node
        return ref(node)
    }, [])
    return { setButtonReference, setListReference }
}

export function SelectFunction(setOpen, submit) {
    return (item) => {
        setOpen(false)
        return submit(item.value)
    }
}

export function DisplayValue(value) {
    if (value === "DOCUMENT") return "Document"
    if (value === "EVENT") return "Event"
    if (value === "All (Default)" || "ALL") return "All (Default)"
}

const Dropdown = ({ text, value, options, submit, maxWidth, ghost, full, disabled }) => {
    const [isOpen, setOpen] = useState(false)
    const listRef = useRef(null)
    const buttonRef = useRef(null)

    const dropdownStyles = {
        width: rem(maxWidth)
    }

    const dropdownClasses = classname({
        'dropdown__button': true,
        'dropdown__button--modified': true,
        'dropdown__button--disabled': disabled,
        'dropdown__button--ghost': ghost,
        'dropdown__button--full': full
    })

    useEffect(() => {
        const clickCheckCb = (e) => clickCheck(isOpen, listRef, buttonRef, setOpen, e);
        document.addEventListener('mousedown', clickCheckCb)
        return () => {
            return document.removeEventListener('mousedown', clickCheckCb)
        }
    }, [isOpen])

    const { setButtonReference, setListReference } = SetDataForButtonReference(buttonRef, listRef)

    const Select = SelectFunction(setOpen, submit)

    return (
        <Manager>
            <Reference>
                {({ ref }) => (
                    <div tabIndex="0"
                        className={dropdownClasses}
                        id="openToggle"
                        style={dropdownStyles}
                        ref={node => setButtonReference(node, ref)}
                        onClick={() => Toggle(setOpen, isOpen)}
                    >
                        <div className={"dropdown__label__selected"}><MultiClamp clamp={1}>{DisplayValue(value)}</MultiClamp></div>
                        <div><IconChevronDown /></div>
                    </div>
                )}
            </Reference>
            {isOpen && (
                PopoverFunction(setListReference, maxWidth, isOpen, options, value, Select)
            )}
        </Manager>
    )
}

export default Dropdown
